import modelBaseV2 from "../../model-base-v2.model"

/**
* Store Visit Report model
* 
* @author cmc.nttruong1
*/

const StoreVisitReportModel = {
  search: (body) => {
    return modelBaseV2.post('/api/report/storevisit', { body })
  },
  getListBU: (siteId) => {
    return modelBaseV2.get('/api/site/:siteId/bu', { params: { siteId } })
  },
  exportExcel: (body, fileName) => {
    return modelBaseV2.postDownload('/api/report/storevisit/export', { body }, fileName)
  }
}

export default StoreVisitReportModel;